import { Dispatch, SetStateAction } from 'react';
import { Button } from '../../ui/button';
import { Link } from '@/components/ui/link';

const HumanHandover = ({
	setHumanHandover,
	humanHandoverUrl = '',
}: {
	setHumanHandover: Dispatch<SetStateAction<boolean>>;
	humanHandoverUrl?: string;
}) => {
	return (
		<section className='wlcb-gap-y-space-100 wlcb-flex wlcb-flex-col'>
			<div className='wlcb-flex wlcb-flex-col wlcb-gap-y-space-025'>
				<h3 className='wlcb-text-body'>Behöver du personlig hjälp?</h3>
				<p className='wlcb-text-caption'>
					Vårt team finns här för dig – prata direkt med en av våra medarbetare.
				</p>
			</div>
			<div className='wlcb-flex wlcb-items-center wlcb-justify-between wlcb-gap-x-space-050'>
				<Link
					className='wlcb-flex-1 !wlcb-justify-start'
					variant='primary'
					name='Ja'
					size='lg'
					href={humanHandoverUrl}
					openInNewWindow={true}
					tabIndex={0}
				/>
				<Button
					className='wlcb-flex-1 !wlcb-justify-start'
					variant='secondary'
					name='Nej'
					size='lg'
					onClick={() => setHumanHandover(false)}
				/>
			</div>
		</section>
	);
};

export default HumanHandover;
